import { render, staticRenderFns } from "./news.vue?vue&type=template&id=4ca24040&"
var script = {}
import style0 from "./news.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "news.vue"
export default component.exports